var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEllipse201(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 184,
    viewBox: "0 0 108 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8256 134.07C37.3593 83.1288 24.2602 -6.81362 62.0401 0.998622C99.82 8.81087 114.808 53.5469 104.274 104.488C93.7404 155.429 54.5744 190.392 16.7946 182.58C-20.9853 174.767 16.2918 185.011 26.8256 134.07Z",
    fill: "#0D6638"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipse201);
export default __webpack_public_path__ + "static/media/Ellipse 201.67bc6306eb6d58b6acfe1b534de74e5b.svg";
export { ForwardRef as ReactComponent };